import React from "react";
import FormSection from "../FormSection";
import TitleWithContentSection from "../TitleWithContentSection";

export const sectionsMap: { [sectionTypeName: string]: React.ElementType } = {
  "form-section": FormSection,
  "title-with-content": TitleWithContentSection
};
